<template>
  <div class="table overflow-auto">
    <loading
      :active.sync="loading"
      :can-cancel="false"
      color="#5739B2"
      :z-index="9"
    ></loading>

    <vuetable
      ref="vuetable"
      track-by="id"
      :apiMode="apiMode"
      :apiUrl="apiUrl"
      :fields="fields"
      :httpOptions="httpOptions"
      :perPage="itemsPerPage"
      data-path="data"
      pagination-path="pagination"
      :data="data"
      :reload="onReload"
    >
      <template slot="index" slot-scope="props">
        {{ props.rowIndex + 1 }}
      </template>
      <template slot="actions" slot-scope="props">
        <slot name="actions" v-bind="props" />
      </template>
    </vuetable>
  </div>
</template>

<script>
export default {
  props: {
    actions: {
      type: Boolean,
      default: true,
    },
    apiMode: {
      type: Boolean,
      default: false,
    },
    apiUrl: {
      type: String,
    },
    httpOptions: {
      type: Object,
      default: () => {},
    },
    fields: {
      type: Array,
      required: true,
    },
    itemsPerPage: {
      type: Number,
      default: 10,
    },
    rowIndex: {
      type: Number,
    },
    data: {
      type: Array,
      default: [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: this.isLoading,
    };
  },
  methods: {
    onReload() {
      this.$emit("reload");
    },
  },
};
</script>

<style lang="scss">
.table th,
.table td {
  vertical-align: middle !important;
}
thead {
  color: #fff;
  background: #6a92fd;
}
.btn.btn-info {
  background-color: #469598 !important;
  border-color: #469598 !important;
}
</style>
